import { useContext } from 'react';
import { ClassificacaoIbsCbsContextData } from '../types/context';
import { ClassificacaoIbsCbsContext } from '../context/classificacaoIbsCbsContext';

export const useClassificacaoIbsCbs = (): ClassificacaoIbsCbsContextData =>
  useContext(ClassificacaoIbsCbsContext);
